export default "__VITE_ASSET__897d4598__"